import { Input, InputError, Select, Toggle } from '@foodsby/nutrient'
import { getYear } from 'date-fns'
import { get } from 'lodash'
import React, { useCallback } from 'react'

import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'

export const CreditCardDetail = ({
  creditCards,
  errors,
  handleBlur,
  handleChange,
  setFieldTouched,
  setFieldValue,
  touched,
  values,
}) => {
  const months = [
    { label: '01', value: '01' },
    { label: '02', value: '02' },
    { label: '03', value: '03' },
    { label: '04', value: '04' },
    { label: '05', value: '05' },
    { label: '06', value: '06' },
    { label: '07', value: '07' },
    { label: '08', value: '08' },
    { label: '09', value: '09' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
  ]

  const yearStart = getYear(new Date())
  const years = Array(20)
    .fill()
    .map((_, i) => yearStart + i)

  const YEAR = years.map(year => ({
    label: year,
    value: year,
  }))
  const getError = useCallback(name => get(touched, name) && get(errors, name), [errors, touched])

  return (
    <div className={creditCards && creditCards.length > 0 ? 'row segment-push' : 'row'}>
      <div className="col-xs-12 col-md-6 _lr-hide">
        <div className="Input">
          <Input
            autocomplete="cc-number"
            format="#### #### #### #### ###"
            id="cc.number"
            isValid={!getError('cc.number')}
            label="Credit Card Number"
            name="cc.number"
            onBlur={event => {
              handleBlur(event)
              pushSnowplow(
                toOrderProcessSchema(
                  'daily',
                  'checkout_credit_card_number',
                  null,
                  getError('cc.number'),
                ),
              )
            }}
            onChange={handleChange}
            type="text"
            value={values.cc.number}
          />
          <InputError>{getError('cc.number')}</InputError>
        </div>
      </div>
      <div className="col-xs-12 col-md-2 _lr-hide">
        <div className="Input">
          <Input
            autocomplete="cc-csc"
            format="####"
            id="cc.cvv"
            isValid={!getError('cc.cvv')}
            label="CVV"
            min="0"
            name="cc.cvv"
            onBlur={event => {
              handleBlur(event)
              pushSnowplow(
                toOrderProcessSchema('daily', 'checkout_credit_card_cvv', null, getError('cc.cvv')),
              )
            }}
            onChange={handleChange}
            type="text"
            value={values.cc.cvv}
          />
          <InputError>{getError('cc.cvv')}</InputError>
        </div>
      </div>
      <div className="col-xs-12 col-md-4 Select--group">
        <label htmlFor="expiry">Expiration Date </label>
        <div className="row">
          <div className="col-xs-6">
            <div className="Select">
              <Select
                autocomplete="cc-exp-month"
                format="####"
                id="cc.expMonth"
                name="cc.expMonth"
                onBlur={() => {
                  setFieldTouched('cc.expMonth', true)
                  pushSnowplow(
                    toOrderProcessSchema(
                      'daily',
                      'checkout_credit_card_exp_date_month',
                      null,
                      getError('cc.expMonth'),
                    ),
                  )
                }}
                onChange={event => {
                  setFieldValue('cc.expMonth', event.value)
                }}
                options={months}
                placeholder="MM"
                value={{ label: values.cc.expMonth, value: values.cc.expMonth }}
              />
              <InputError>{getError('cc.expMonth')}</InputError>
            </div>
          </div>
          <div className="col-xs-6">
            <div className="Select">
              <Select
                autocomplete="cc-exp-year"
                id="cc.expYear"
                name="cc.expYear"
                onBlur={() => {
                  setFieldTouched('cc.expYear', true)
                  pushSnowplow(
                    toOrderProcessSchema(
                      'daily',
                      'checkout_credit_card_exp_date_year',
                      null,
                      getError('cc.expYear'),
                    ),
                  )
                }}
                onChange={event => {
                  setFieldValue('cc.expYear', event.value)
                }}
                options={YEAR}
                placeholder="YYYY"
                value={{ label: values.cc.expYear, value: values.cc.expYear }}
              />
              <InputError>{getError('cc.expYear')}</InputError>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12 col-md-6">
        <div className="Input">
          <Input
            autocomplete="cc-given-name"
            id="firstName"
            isValid={!getError('cc.firstName')}
            label="First Name"
            name="cc.firstName"
            onBlur={event => {
              handleBlur(event)
              pushSnowplow(
                toOrderProcessSchema(
                  'daily',
                  'checkout_credit_card_first_name',
                  null,
                  getError('cc.firstName'),
                ),
              )
            }}
            onChange={handleChange}
            type="text"
            value={values.cc.firstName}
          />
          <InputError>{getError('cc.firstName')}</InputError>
        </div>
      </div>
      <div className="col-xs-12 col-md-6">
        <div className="Input">
          <Input
            autocomplete="cc-family-name"
            id="lastName"
            isValid={!getError('cc.lastName')}
            label="Last Name"
            name="cc.lastName"
            onBlur={event => {
              pushSnowplow(
                toOrderProcessSchema(
                  'daily',
                  'checkout_credit_card_last_name',
                  null,
                  getError('cc.lastName'),
                ),
              )
              handleBlur(event)
            }}
            onChange={handleChange}
            type="text"
            value={values.cc.lastName}
          />
          <InputError>{getError('cc.lastName')}</InputError>
        </div>
      </div>
      <div className="col-xs-4">
        <div className="Input">
          <Input
            autocomplete="postal-code"
            format="#####"
            id="zip"
            isValid={!getError('cc.zip')}
            label="Zip Code"
            name="cc.zip"
            onBlur={event => {
              pushSnowplow(
                toOrderProcessSchema(
                  'daily',
                  'checkout_credit_card_zip_code',
                  null,
                  getError('cc.zip'),
                ),
              )
              handleBlur(event)
            }}
            onChange={handleChange}
            type="text"
            value={values.cc.zip}
          />
          <InputError>{getError('cc.zip')}</InputError>
        </div>
      </div>
      <div className="col-xs-6 col-xs-offset-2 Toggle">
        <Toggle
          checked={values.saveCard}
          checkedLabel="Yes"
          className="Toggle"
          id="saveCard"
          name="saveCard"
          onBlur={event => {
            pushSnowplow(
              toOrderProcessSchema('daily', 'checkout_credit_card_save', event.target.checked),
            )
            handleBlur(event)
          }}
          onChange={handleChange}
          title="Save this card for future use?"
          uncheckedLabel="No"
        />
      </div>
    </div>
  )
}
export default CreditCardDetail
